import { jsx as _jsx } from "react/jsx-runtime";
import "./loadingIcon2.style.css";
export const LoadingIcon2 = () => {
    return (_jsx("div", { className: "arc" }));
};
